import React, { useState } from 'react';
import { toast } from 'sonner';
import { FileText, Loader2, Send } from 'lucide-react';
import { resolveUrl } from './driverUtils';

export const reportUrl = (job) => resolveUrl(job.report_url || `/api/jobs/${job.id}/report.pdf`);

export const ReportActions = ({ job, authFetch, onUpdated }) => {
  const [busy, setBusy] = useState(false);
  if (!job.booking) return null;

  const send = async () => {
    if (!job.email) return toast.error('No customer email on this job.');
    const again = job.report_sent_at ? ' again' : '';
    if (!window.confirm(`Email the job report${again} to ${job.email}?`)) return;
    setBusy(true);
    try {
      await authFetch('post', `/jobs/${job.id}/send-report`);
      toast.success(`Job report emailed to ${job.email}.`);
      onUpdated?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't send the report.");
    } finally { setBusy(false); }
  };

  return (
    <div className="rounded-md border border-slate-200 bg-white p-3 space-y-2" data-testid={`report-actions-${job.ref}`}>
      <div className="text-[10px] font-black uppercase tracking-wider text-slate-500">Job report (PDF)</div>
      <div className="flex flex-wrap gap-2">
        <a href={reportUrl(job)} target="_blank" rel="noreferrer" className="h-11 px-3 rounded-md border border-slate-200 text-sm font-bold text-[color:var(--mv-navy)] inline-flex items-center gap-1.5 hover:border-[color:var(--mv-orange)]" data-testid={`report-view-${job.ref}`}>
          <FileText className="w-4 h-4 text-[color:var(--mv-orange)]" /> View report
        </a>
        <button type="button" onClick={send} disabled={busy || !job.email} className="h-11 px-4 rounded-md bg-[color:var(--mv-orange)] hover:bg-orange-600 disabled:opacity-50 text-white text-sm font-bold inline-flex items-center gap-1.5" data-testid={`report-send-${job.ref}`}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} {job.report_sent_at ? 'Resend report' : 'Send report'}
        </button>
      </div>
      <div className="text-[11px] text-slate-500" data-testid={`report-status-${job.ref}`}>
        {!job.email ? 'No customer email — the report can only be viewed or downloaded.'
          : job.report_sent_at ? `Sent ${new Date(job.report_sent_at + 'Z').toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}`
          : 'Not sent yet'}
      </div>
    </div>
  );
};
